export const Team = ({ team, align = "left" }) => (
  <div className={`flex items-center gap-2 min-w-0 ${align === "right" ? "flex-row-reverse text-right" : ""}`}>
    <img src={team.crest} alt="" className="h-7 w-7 object-contain shrink-0" loading="lazy" />
    <span className="font-semibold truncate">{team.short_name || team.name}</span>
  </div>
);
